import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'reflexbox';

import { Card, Subheading, Paragraph } from '@treams/treams-ui';

import HelpIcon from 'packages/kakapo-ui-kit/assets/icons/HelpIcon';
import { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';
import PopoverTarget from 'packages/kakapo-ui-kit/components/popovers/PopoverTarget';

const Link = styled(Box)`
	cursor: pointer;
	color: ${(props) => props.theme.colors.slateBlue};
	text-decoration: underline;
	font-size: 14px;
	flex-grow: 0;
	flex-shrink: 0;

	&:hover {
		text-decoration: none;

		&:active {
			color: black;
		}
	}
`;

export default function DashboardCard(
	props: PropsWithChildren<{
		title?: string;
		description?: string;
		link?: string;
		onLinkClick?: () => void;
		explanation?: string;
	}>,
) {
	return (
		<Card>
			{(props.title || props.description) && (
				<Flex>
					<Box pb={0} flexShrink={1} flexGrow={1}>
						{props.title && (
							<Flex mb={2} alignItems="baseline">
								<Subheading>{props.title}</Subheading>
								{props.link && <Link onClick={props.onLinkClick}>{props.link}</Link>}
							</Flex>
						)}
						{props.description && <Paragraph mb={2}>{props.description}</Paragraph>}
					</Box>
					{props.explanation && (
						<Box py={3} pr={3} flexShrink={0} flexGrow={0}>
							<PopoverTarget
								content={
									<Box p={3}>
										<ParagraphSmall color="slateBlue">{props.explanation}</ParagraphSmall>
									</Box>
								}
							>
								<HelpIcon color="slateBlue" />
							</PopoverTarget>
						</Box>
					)}
				</Flex>
			)}
			{props.children}
		</Card>
	);
}
